import { Skeleton } from '../skeleton';

interface NavigationSkeletonProps {
  level?: number;
  showIcon?: boolean;
  isNested?: boolean;
}

export function NavigationSkeleton({
  level = 0,
  showIcon = true,
  isNested = false,
}: NavigationSkeletonProps) {
  const paddingLeft = isNested ? 'pl-6' : '';
  const bgColor = isNested ? 'bg-gray-200/30' : 'bg-gray-300/40';

  return (
    <div
      className={`flex items-center gap-3 py-2 px-3 rounded-md ${paddingLeft} ${bgColor} hover:bg-white/50 transition-colors`}
    >
      {showIcon && <Skeleton className="h-5 w-5 rounded bg-white/70" />}
      <div className="flex-1 space-y-1">
        <Skeleton className="h-4 w-24 bg-white/70" />
        {level > 0 && <Skeleton className="h-3 w-16 bg-white/60" />}
      </div>
    </div>
  );
}
